import { createAction } from 'redux-actions';

export const selectNavItem = createAction('SELECT_NAV_ITEM');
